
<!--CLICK FUNNELS-->
<ng-container  *ngIf="data_clickfunnels.length > 0">

  <mat-expansion-panel style="margin-bottom: 15px">
    <mat-expansion-panel-header>
      <mat-panel-title>
        Purchases
      </mat-panel-title>
    </mat-expansion-panel-header>

  <div style="margin-left: 20px; width: 800px;">
    <br>
    <mat-form-field appearance="standard">
      <mat-label>Filter</mat-label>
      <input matInput (keyup)="applyFilterClickfunnels($event)" placeholder="Ex. Mia" #input>
    </mat-form-field>

    <div ngClass="table-width" ngClass.xs="table-width-xs" ngClass.sm="table-width-sm">
      <mat-card class="mat-elevation-z24">
        <mat-card-title></mat-card-title>
        <mat-card-content>

          <div class="example-container mat-elevation-z24">
            <table mat-table [dataSource]="dataSourceCf" matSort>

              <!-- Pruchase DTColumn -->
              <ng-container matColumnDef="purchase_dt" sticky>
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
                <td mat-cell *matCellDef="let row"> {{row.purchase_dt}} </td>
              </ng-container>

              <!-- Service Column -->
              <ng-container matColumnDef="service" sticky>
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Service</th>
                <td mat-cell *matCellDef="let row"> {{row.service}} </td>
              </ng-container>


              <!-- Amount Column -->
              <ng-container  matColumnDef="amount">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Product Price</th>
                <td mat-cell *matCellDef="let row"> {{row.amount | currency}} </td>
              </ng-container>

              <!--description-->
              <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Product Name</th>
                <td mat-cell *matCellDef="let row"> {{row.description}} </td>
              </ng-container>

              <!--fullName-->
              <ng-container matColumnDef="fullName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Lead Name</th>
                <td mat-cell *matCellDef="let row"> {{row.fullName}} </td>
              </ng-container>

              <!--emailAddress-->
              <ng-container matColumnDef="emailAddress">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
                <td mat-cell *matCellDef="let row"> {{row.emailAddress}} </td>
              </ng-container>

              <!--phoneNumberStandard-->
              <ng-container matColumnDef="phoneNumberStandard">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Phone Number</th>
                <td mat-cell *matCellDef="let row"> {{row.phoneNumberStandard}} </td>
              </ng-container>

              <!-- first_event_dt Column -->
              <ng-container matColumnDef="first_event_dt">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>First Source Date</th>
                <td mat-cell *matCellDef="let row"> {{row.first_event_dt}} </td>
              </ng-container>


              <!--first_action_id-->
              <ng-container matColumnDef="first_action_id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>First Click Source</th>
                <td mat-cell *matCellDef="let row"> {{row.first_action_id}}  </td>
              </ng-container>

              <!--first_provider-->
              <ng-container matColumnDef="first_provider">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>First Provider</th>
                <td mat-cell *matCellDef="let row"> {{row.first_provider}}  </td>
              </ng-container>

              <!--first_adgroup-->
              <ng-container matColumnDef="first_source_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>First Source</th>
                <td mat-cell *matCellDef="let row"> {{row.first_source_name}}  </td>
              </ng-container>

              <!-- Star Column -->
              <ng-container matColumnDef="star" stickyEnd>
                <th mat-header-cell [hidden]="is_table_column_hidden" *matHeaderCellDef></th>
                <td mat-cell [hidden]="is_table_column_hidden" *matCellDef="let element">
                  <mat-icon>more_vert</mat-icon>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumnsCf"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumnsCf;" class="element-row"
                  (click)="getTableRecord(row)"></tr>

              <!-- Row shown when there is no matching data. -->
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">No data matching the filter "{{input.value}}"</td>
              </tr>
            </table>

          </div>

          <div class="example-container">
            <mat-paginator [pageSize]="10"
                           [pageSizeOptions]="[5, 10, 25, 100]"
                           showFirstLastButtons></mat-paginator>
          </div>


        </mat-card-content>
      </mat-card>
    </div>
  </div>
    </mat-expansion-panel>
</ng-container>

<!--CALENDY-->
<ng-container  *ngIf="data_calendly.length > 0">

  <mat-expansion-panel style="margin-bottom: 15px">
    <mat-expansion-panel-header>
      <mat-panel-title>
        Calandar
      </mat-panel-title>
    </mat-expansion-panel-header>


  <div style="margin-left: 20px; width: 800px;">
    <br>
    <mat-form-field appearance="standard">
      <mat-label>Filter</mat-label>
      <input matInput (keyup)="applyFilterCalendy($event)" placeholder="Ex. Mia" #input>
    </mat-form-field>

    <div ngClass="table-width" ngClass.xs="table-width-xs" ngClass.sm="table-width-sm">
      <mat-card class="mat-elevation-z24">
        <mat-card-title></mat-card-title>
        <mat-card-content>

          <div class="example-container mat-elevation-z24">
            <table mat-table [dataSource]="dataSourceCalendly" matSort>

              <!-- Pruchase DTColumn -->
              <ng-container matColumnDef="purchase_dt" sticky>
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
                <td mat-cell *matCellDef="let row"> {{row.purchase_dt}} </td>
              </ng-container>

              <!-- Service Column -->
              <ng-container matColumnDef="service" sticky>
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Service</th>
                <td mat-cell *matCellDef="let row"> {{row.service}} </td>
              </ng-container>

              <!--fullName-->
              <ng-container matColumnDef="fullName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Lead Name</th>
                <td mat-cell *matCellDef="let row"> {{row.fullName}} </td>
              </ng-container>

              <!--emailAddress-->
              <ng-container matColumnDef="emailAddress">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
                <td mat-cell *matCellDef="let row"> {{row.emailAddress}} </td>
              </ng-container>

              <!--phoneNumberStandard-->
              <ng-container matColumnDef="phoneNumberStandard">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Phone Number</th>
                <td mat-cell *matCellDef="let row"> {{row.phoneNumberStandard}} </td>
              </ng-container>

              <!-- first_event_dt Column -->
              <ng-container matColumnDef="first_event_dt">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>First Source Date</th>
                <td mat-cell *matCellDef="let row"> {{row.first_event_dt}} </td>
              </ng-container>


              <!--first_action_id-->
              <ng-container matColumnDef="first_action_id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>First Click Source</th>
                <td mat-cell *matCellDef="let row"> {{row.first_action_id}}  </td>
              </ng-container>

              <!--first_provider-->
              <ng-container matColumnDef="first_provider">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>First Provider</th>
                <td mat-cell *matCellDef="let row"> {{row.first_provider}}  </td>
              </ng-container>

              <!--first_adgroup-->
              <ng-container matColumnDef="first_source_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>First Source</th>
                <td mat-cell *matCellDef="let row"> {{row.first_source_name}}  </td>
              </ng-container>

              <!-- Star Column -->
              <ng-container matColumnDef="star" stickyEnd>
                <th mat-header-cell [hidden]="is_table_column_hidden" *matHeaderCellDef></th>
                <td mat-cell [hidden]="is_table_column_hidden" *matCellDef="let element">
                  <mat-icon>more_vert</mat-icon>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumnsCalendly"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumnsCalendly;" class="element-row"
                  (click)="getTableRecord(row)"></tr>

              <!-- Row shown when there is no matching data. -->
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">No data matching the filter "{{input.value}}"</td>
              </tr>
            </table>

          </div>

          <div class="example-container">
            <mat-paginator [pageSize]="10"
                           [pageSizeOptions]="[5, 10, 25, 100]"
                           showFirstLastButtons></mat-paginator>
          </div>


        </mat-card-content>
      </mat-card>
    </div>
  </div>
    </mat-expansion-panel>
</ng-container>

<!--EMAIL-->
<ng-container  *ngIf="data_email.length > 0">

  <mat-expansion-panel style="margin-bottom: 15px">
    <mat-expansion-panel-header>
      <mat-panel-title>
        Email
      </mat-panel-title>
    </mat-expansion-panel-header>


  <div style="margin-left: 20px; width: 800px;">
    <br>
    <mat-form-field appearance="standard">
      <mat-label>Filter</mat-label>
      <input matInput (keyup)="applyFilterEmail($event)" placeholder="Ex. Mia" #input>
    </mat-form-field>

    <div ngClass="table-width" ngClass.xs="table-width-xs" ngClass.sm="table-width-sm">
      <mat-card class="mat-elevation-z24">
        <mat-card-title></mat-card-title>
        <mat-card-content>

          <div class="example-container mat-elevation-z24">
            <table mat-table [dataSource]="dataSourceEmail" matSort>

              <!-- Pruchase DTColumn -->
              <ng-container matColumnDef="purchase_dt" sticky>
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
                <td mat-cell *matCellDef="let row"> {{row.purchase_dt}} </td>
              </ng-container>

              <!-- Service Column -->
              <ng-container matColumnDef="service" sticky>
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Service</th>
                <td mat-cell *matCellDef="let row"> {{row.service}} </td>
              </ng-container>

              <!--fullName-->
              <ng-container matColumnDef="fullName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Lead Name</th>
                <td mat-cell *matCellDef="let row"> {{row.fullName}} </td>
              </ng-container>

              <!--emailAddress-->
              <ng-container matColumnDef="emailAddress">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
                <td mat-cell *matCellDef="let row"> {{row.emailAddress}} </td>
              </ng-container>

              <!--phoneNumberStandard-->
              <ng-container matColumnDef="phoneNumberStandard">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Phone Number</th>
                <td mat-cell *matCellDef="let row"> {{row.phoneNumberStandard}} </td>
              </ng-container>

              <!-- first_event_dt Column -->
              <ng-container matColumnDef="first_event_dt">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>First Source Date</th>
                <td mat-cell *matCellDef="let row"> {{row.first_event_dt}} </td>
              </ng-container>


              <!--first_action_id-->
              <ng-container matColumnDef="first_action_id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>First Click Source</th>
                <td mat-cell *matCellDef="let row"> {{row.first_action_id}}  </td>
              </ng-container>

              <!--first_provider-->
              <ng-container matColumnDef="first_provider">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>First Provider</th>
                <td mat-cell *matCellDef="let row"> {{row.first_provider}}  </td>
              </ng-container>

              <!--first_adgroup-->
              <ng-container matColumnDef="first_source_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>First Source</th>
                <td mat-cell *matCellDef="let row"> {{row.first_source_name}}  </td>
              </ng-container>

              <!-- Star Column -->
              <ng-container matColumnDef="star" stickyEnd>
                <th mat-header-cell [hidden]="is_table_column_hidden" *matHeaderCellDef></th>
                <td mat-cell [hidden]="is_table_column_hidden" *matCellDef="let element">
                  <mat-icon>more_vert</mat-icon>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumnsEmail"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumnsEmail;" class="element-row"
                  (click)="getTableRecord(row)"></tr>

              <!-- Row shown when there is no matching data. -->
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">No data matching the filter "{{input.value}}"</td>
              </tr>
            </table>

          </div>

          <div class="example-container">
            <mat-paginator [pageSize]="10"
                           [pageSizeOptions]="[5, 10, 25, 100]"
                           showFirstLastButtons></mat-paginator>
          </div>


        </mat-card-content>
      </mat-card>
    </div>
  </div>
    </mat-expansion-panel>
</ng-container>

<!--FORM -->
<ng-container *ngIf="data_form.length > 0">

  <mat-expansion-panel style="margin-bottom: 15px">
    <mat-expansion-panel-header>
      <mat-panel-title>
        Form
      </mat-panel-title>
    </mat-expansion-panel-header>


  <div style="margin-left: 20px; width: 800px;">
    <br>
    <mat-form-field appearance="standard">
      <mat-label>Filter</mat-label>
      <input matInput (keyup)="applyFilterForm($event)" placeholder="Ex. Mia" #input>
    </mat-form-field>

    <div ngClass="table-width" ngClass.xs="table-width-xs" ngClass.sm="table-width-sm">
      <mat-card class="mat-elevation-z24">
        <mat-card-title></mat-card-title>
        <mat-card-content>

          <div class="example-container mat-elevation-z24">
            <table mat-table [dataSource]="dataSourceForm" matSort>

              <!-- Pruchase DTColumn -->
              <ng-container matColumnDef="purchase_dt" sticky>
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
                <td mat-cell *matCellDef="let row"> {{row.purchase_dt}} </td>
              </ng-container>

              <!-- Service Column -->
              <ng-container matColumnDef="service" sticky>
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Service</th>
                <td mat-cell *matCellDef="let row"> {{row.service}} </td>
              </ng-container>

              <!--fullName-->
              <ng-container matColumnDef="fullName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Lead Name</th>
                <td mat-cell *matCellDef="let row"> {{row.fullName}} </td>
              </ng-container>

              <!--emailAddress-->
              <ng-container matColumnDef="emailAddress">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
                <td mat-cell *matCellDef="let row"> {{row.emailAddress}} </td>
              </ng-container>

              <!--phoneNumberStandard-->
              <ng-container matColumnDef="phoneNumberStandard">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Phone Number</th>
                <td mat-cell *matCellDef="let row"> {{row.phoneNumberStandard}} </td>
              </ng-container>

              <!-- first_event_dt Column -->
              <ng-container matColumnDef="first_event_dt">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>First Source Date</th>
                <td mat-cell *matCellDef="let row"> {{row.first_event_dt}} </td>
              </ng-container>


              <!--first_action_id-->
              <ng-container matColumnDef="first_action_id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>First Click Source</th>
                <td mat-cell *matCellDef="let row"> {{row.first_action_id}}  </td>
              </ng-container>

              <!--first_provider-->
              <ng-container matColumnDef="first_provider">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>First Provider</th>
                <td mat-cell *matCellDef="let row"> {{row.first_provider}}  </td>
              </ng-container>

              <!--first_adgroup-->
              <ng-container matColumnDef="first_source_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>First Source</th>
                <td mat-cell *matCellDef="let row"> {{row.first_source_name}}  </td>
              </ng-container>

              <!-- Star Column -->
              <ng-container matColumnDef="star" stickyEnd>
                <th mat-header-cell [hidden]="is_table_column_hidden" *matHeaderCellDef></th>
                <td mat-cell [hidden]="is_table_column_hidden" *matCellDef="let element">
                  <mat-icon>more_vert</mat-icon>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumnsForm"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumnsForm;" class="element-row"
                  (click)="getTableRecord(row)"></tr>

              <!-- Row shown when there is no matching data. -->
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">No data matching the filter "{{input.value}}"</td>
              </tr>
            </table>

          </div>

          <div class="example-container">
            <mat-paginator [pageSize]="10"
                           [pageSizeOptions]="[5, 10, 25, 100]"
                           showFirstLastButtons></mat-paginator>
          </div>


        </mat-card-content>
      </mat-card>
    </div>
  </div>
  </mat-expansion-panel>
</ng-container>
